import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let Notiedit = () => {
  let [data, setData] = useState();

  let [one, setOne] = useState();
  let [two, setTwo] = useState();
  let [three, setThree] = useState();
  let [four, setFour] = useState();

  let [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  const [text, setText] = useState("");

  useEffect(() => {
    Start();
 
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };
 

  let submit = async () =>{ 
    if(one === undefined || one === null || one === 'null' || one === '') {
      alert('Enter value')
      return
    }
    console.log('clickeddd' , one) 
 

    
    setLoading(true); 
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, one };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/changenotification",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          console.log(Jsson, "Jsson");
          if (Jsson.status === true) {
            setData(Jsson.data);
          } else {
            alert("Failed");
          }
        })
        .catch((ee) => {});
    } catch (err) {}
    setLoading(false);
   



  }

   

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10" style={{ overflowY : 'scroll' ,  scrollbarWidth : 'none' }} >
          <p style={{ fontWeight: "700", marginTop: 20 }}>Notification Edit</p>
 
        <textarea onChange={(e)=>{
          setOne(e.target.value)
        }} style={{ width : "60%" , }}   /> 
        <button style={{ marginLeft :  20 ,  }} onClick={()=>{
          submit()
        }} >Submit</button>
        </div>

        
      </div>
    </div>
  );
};

export default Notiedit;
